<!--
  La colonne « Dépôt SUMAL » du mail (depotCell + ocolLine) : statut du dépôt,
  ouverture, județ, puis l'ocol qui a émis l'APV et le vendeur quand ce n'est
  pas lui. `ocol` vient du serveur (ocolResolver), jamais deviné ici.
-->
<template>
  <div>
    <span v-if="!p || !p.in_sumal" class="hv2-muted">inconnu de SUMAL</span>
    <template v-else>
      <hv-pill :label="status.label" :tone="status.tone" />
      <div v-if="lines" class="hv2-cell-line">{{ lines }}</div>
      <div v-if="ocol && ocol.ocol" class="hv2-cell-line">Ocol : <b>{{ ocol.ocol }}</b></div>
      <div v-if="ocol && ocol.vendeur" class="hv2-cell-line">Vendeur : <b>{{ ocol.vendeur }}</b></div>
    </template>
  </div>
</template>

<script>
import fmt from '../format'
import HvPill from './HvPill'

export default {
  name: 'HvDepotCell',
  components: { HvPill },
  props: {
    p: { type: Object, default: null },
    ocol: { type: Object, default: null }
  },
  computed: {
    status () {
      const st = String(this.p.sumal_depot_status || '').toUpperCase()
      if (st === 'ACTIVE') return { label: 'Actif', tone: 'ok' }
      if (st === 'INACTIVE') return { label: `Fermé le ${fmt.date(this.p.date_closed)}`, tone: '' }
      return { label: st === 'SUSPENDED' ? 'Suspendu' : (st || '?'), tone: 'warn' }
    },
    lines () {
      const out = []
      if (this.p.date_opened) out.push(`ouvert le ${fmt.date(this.p.date_opened)}`)
      if (this.p.sumal_county) out.push(this.p.sumal_county)
      return out.join(' · ')
    }
  }
}
</script>
